import { Props } from '~/containers/Claims';

function meetsDataDependencies({ application, currentProperty }: Props) {
  return application.hasAuto || currentProperty.newPurchase === false;
}

const step = {
  route: '/homeowners-insurance/quotes/claims',
  breadcrumbStep: 'property',
  isAccessible: ({ application, currentProperty }: Props): boolean =>
    application.bundled || !currentProperty.newPurchase || application.isAutoOnly,
  meetsDataDependencies,
};

export default step;
